import SeparatorBar from 'pages/product-full-view/components/product-media-area/nutrition-label/components/SeparatorBar';
import { parseNumber } from 'utils/parser';
import { getUomTypesAbbreviations } from '../constants';
import { useGetBasicUomEnum } from 'hooks';

function NutrientSideBySide({ nutrient, showDot }) {
  const {
    nutritionName,
    quantity,
    quantityUom,
    dailyValueIntakePercent,
    hideBar,
  } = nutrient;

  const { basicUomProperties } = useGetBasicUomEnum();

  const showAbbr = (quantityUom, defaultUom = 'g') => {
    return (
      getUomTypesAbbreviations(basicUomProperties, quantityUom) ?? defaultUom
    );
  };

  const gram =
    parseNumber(quantity) !== ''
      ? `${parseNumber(quantity)}${showAbbr(quantityUom, 'g')}`
      : null;

  const percent = parseNumber(dailyValueIntakePercent);

  return (
    <>
      <div className='tab-qa-fact-panels__vitamin'>
        {showDot && <div>•</div>}
        <div>
          {nutritionName} {gram ? gram : null}{' '}
          {percent === 0 || percent > 0 ? `${percent}%` : null}
        </div>
      </div>
      {hideBar ? null : <SeparatorBar indentBar={0} />}
    </>
  );
}

export default NutrientSideBySide;
